import axios from "axios";
import store from "../store/store";

const urlAxios = axios.create({
  baseURL: import.meta.env.VITE_MAIN_API_URL,
  headers: {
    "X-Request-Agent": "gema-dashboard",
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
urlAxios.interceptors.request.use(
  (config) => {
    // Get the current auth token from Redux store
    const state = store.getState();
    const authToken = state.auth?.authToken;

    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    } else {
      // Fallback to environment API token for public endpoints if needed
      const apiToken = import.meta.env.VITE_MAIN_API_TOKEN;
      if (apiToken) {
        config.headers.Authorization = `Bearer ${apiToken}`;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration
urlAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // If we get a 401 (Unauthorized), the token might be expired
    if (error.response?.status === 401) {
      // Clear the auth state and redirect to login
      const state = store.getState();
      if (state.auth?.authToken) {
        store.dispatch({ type: "[Logout] Action" });
        window.location.href = "/auth/login";
      }
    }
    return Promise.reject(error);
  }
);

export async function createUrl(urlDto) {
  try {
    const { data } = await urlAxios.post(`/shorturl`, {
      original: urlDto.original,
      shorten: urlDto.shorten,
      published: urlDto.published !== undefined ? urlDto.published : true,
    });
    return data;
  } catch (error) {
    const { response } = error;
    if (response && response.data) {
      throw new Error(response.data.message || "Failed to create short URL");
    }
    throw new Error(error.message || "Network error");
  }
}

export async function getUrlsByUser() {
  try {
    const { data } = await urlAxios.get(`/shorturl/user`);
    return data;
  } catch (error) {
    console.error("Failed to get URLs:", error);
    throw error;
  }
}

export async function updateUrl(id, urlDto) {
  try {
    const response = await urlAxios.put(`/shorturl/${id}`, urlDto);
    return response.status === 200;
  } catch (error) {
    console.error("Failed to update URL:", error);
    return false;
  }
}

export async function removeUrl(id) {
  try {
    const response = await urlAxios.delete(`/shorturl/${id}`);
    return response.status === 200;
  } catch (error) {
    console.error("Failed to remove URL:", error);
    return false;
  }
}

export async function togglePublishUrl(id) {
  try {
    const response = await urlAxios.patch(`/shorturl/${id}/publish`);
    return response.status === 200;
  } catch (error) {
    console.error("Failed to toggle publish status:", error);
    return false;
  }
}
